
































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CpptRanapPage from "@/components/soap/CpptRanapPage.vue";
import CpptRalanPage from "@/components/soap/CpptRalanPage.vue";
import CardCatatanEdukasi from "@/components/pemeriksaan/assesmen/catatanedukasi/CardCatatanEdukasi.vue";
import TransferInternalPage from "@/components/pti/TransferInternalPage.vue";
import SkriningRawatJalanPage from "@/components/pemeriksaan/SkriningRawatJalanPage.vue";
import PemantauanTerapiGiziPage from "@/components/pemeriksaan/tabs/rekam-medis/PemantauanTerapiGiziPage.vue";
import SkriningGiziLanjutPage from "@/components/pemeriksaan/tabs/rekam-medis/SkriningGiziLanjutPage.vue";
import MppPage from "@/pages/pemeriksaan_ranap/MppPage.vue";
import { storeCatatanEdukasi } from "@/store/modules/catatanedukasi";
import ptiStore from "@/store/modules/pti";
import { scrollTabIntoView } from "@/utils/scrollTabIntoView";
import {
  MPP_TAB,
  PEMANTAUAN_GIZI_TAB,
  PEMERIKSAAN_GIZI_RM_TABS,
  PEMERIKSAAN_REKAM_MEDIS_RM_TABS,
  PEMERIKSAAN_RINGKAS_RM_TABS,
  SKRINING_GIZI_LANJUT_TAB,
  SKRINING_PASIEN_TAB
} from "@/utils/ralanFormRegistry";
import type { FormIndexEntry } from "@/utils/ralanFormRegistry";

@Component({
  components: {
    CpptRanapPage,
    CpptRalanPage,
    CardCatatanEdukasi,
    TransferInternalPage,
    SkriningRawatJalanPage,
    PemantauanTerapiGiziPage,
    SkriningGiziLanjutPage,
    MppPage
  }
})
export default class RekamMedisLabRadiologi extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ type: Boolean, default: false }) readonly cpptRanap!: boolean;
  @Prop({ type: Boolean, default: false }) readonly gizi!: boolean;
  @Prop({ type: Boolean, default: false }) readonly episodeRanap!: boolean;
  @Prop({ type: Boolean, default: false }) readonly mpp!: boolean;
  @Prop({ default: null }) deepLink!: FormIndexEntry | null;

  tab = "tab-soap";
  skriningTab = SKRINING_PASIEN_TAB;
  pemantauanGiziTab = PEMANTAUAN_GIZI_TAB;
  skriningGiziLanjutTab = SKRINING_GIZI_LANJUT_TAB;
  mppTab = MPP_TAB;

  get cpptDefaultTab(): string {
    return this.gizi ? "tab-adime" : "tab-soap";
  }

  get tabTersedia(): ReadonlyArray<string> {
    if (this.mpp) return PEMERIKSAAN_REKAM_MEDIS_RM_TABS;
    if (!this.gizi) return PEMERIKSAAN_RINGKAS_RM_TABS;

    return PEMERIKSAAN_GIZI_RM_TABS.filter(
      id => id !== PEMANTAUAN_GIZI_TAB || this.episodeRanap
    );
  }

  @Watch("tab")
  onTabChange() {
    this.$nextTick(() => scrollTabIntoView(this.$el));
  }

  @Watch("deepLink", { immediate: true })
  onDeepLink(payload: FormIndexEntry | null) {
    if (!payload || payload.topTab !== "tab-assesmen" || !payload.elemId) {
      return;
    }
    this.pilihTab(payload.elemId);
  }

  pilihTab(elemId: string) {
    if (!this.tabTersedia.includes(elemId)) return;

    this.tab = elemId;
    if (elemId === "tab-catatan-edukasi") {
      this.muatCatatanEdukasi();
    }
  }

  muatCatatanEdukasi() {
    storeCatatanEdukasi.actCatatanEdukasi(this.register);
  }

  muatTransferInternal() {
    ptiStore.fetchByRegister(this.register ? Number(this.register) : null);
  }
}
